import { AddNewUserFormState, UserFormAction } from './types';
import { USER_ACCESS_DEFAULT } from './consts';

export const userFormInitialState = {
  emails: [],
  access: USER_ACCESS_DEFAULT,
  allowedSearch: '',
  allowedDashboards: [],
};

export const userFormReducer = (state: AddNewUserFormState, action: UserFormAction): AddNewUserFormState => {
  switch (action.type) {
    case 'setEmails':
      return { ...state, emails: action.payload };
    case 'setAccess':
      return { ...state, access: action.payload };
    case 'setAllowedSearch':
      return { ...state, allowedSearch: action.payload };
    case 'setAllowedDashboards':
      return { ...state, allowedDashboards: action.payload };
    case 'resetState':
      return userFormInitialState;
    default:
      throw new Error();
  }
};
